import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { calculateDigit, withMode } from "../SuperProForm";
import { ProProvider } from '@ant-design/pro-components';
import FieldDigit from '@ant-design/pro-field/lib/components/Digit';
import FieldDigitRange from '@ant-design/pro-field/lib/components/DigitRange';
import FieldMoney from '@ant-design/pro-field/lib/components/Money';
import _ from 'lodash';
import React, { useContext } from 'react';
export var SuperProTableEnhancer = function SuperProTableEnhancer(properties) {
  var parent = useContext(ProProvider);
  var buildPreciseItem = function buildPreciseItem(render) {
    // 调整参数
    var render0 = function render0(text, properties0, defaultElement) {
      // -
      var text0 = function () {
        if (text === 0) {
          return 0;
        } else {
          if (text) {
            if (_.isArray(text)) {
              return text.map(function (text1) {
                return calculateDigit(text1, withMode(properties0, 'read'));
              });
            } else {
              return calculateDigit(text, withMode(properties0, 'read'));
            }
          } else {
            return undefined;
          }
        }
      }();
      // -
      return render(text0, _objectSpread(_objectSpread({}, properties0), {}, {
        fieldProps: _objectSpread(_objectSpread({}, properties0.fieldProps), {}, {
          value: text0,
          onChange: function onChange(value) {
            // -
            var value0 = function () {
              if (value) {
                if (_.isArray(value)) {
                  return value.filter(_.isNumber).map(function (value1) {
                    return calculateDigit(value1, withMode(properties0, 'edit'));
                  });
                } else {
                  return calculateDigit(value, withMode(properties0, 'edit'));
                }
              } else {
                return undefined;
              }
            }();

            // -
            return properties0.fieldProps.onChange(value0);
          }
        })
      }), defaultElement);
    };

    // 构建
    return {
      render: render0,
      renderFormItem: render0
    };
  };
  return /*#__PURE__*/React.createElement(ProProvider.Provider, {
    value: _objectSpread(_objectSpread({}, parent), {}, {
      valueTypeMap: _objectSpread(_objectSpread({}, parent.valueTypeMap), {}, {
        preciseDigit: buildPreciseItem(function (text, properties0) {
          return /*#__PURE__*/React.createElement(FieldDigit, {
            mode: properties0.mode,
            fieldProps: properties0.fieldProps,
            text: text
          });
        }),
        preciseMoney: buildPreciseItem(function (text, properties0) {
          var _parent$intl;
          return /*#__PURE__*/React.createElement(FieldMoney, {
            mode: properties0.mode,
            locale: (_parent$intl = parent.intl) === null || _parent$intl === void 0 ? void 0 : _parent$intl.locale,
            fieldProps: properties0.fieldProps,
            text: text,
            moneySymbol: true
          });
        }),
        preciseDigitRange: buildPreciseItem(function (text, properties0) {
          return /*#__PURE__*/React.createElement(FieldDigitRange, {
            mode: properties0.mode,
            fieldProps: properties0.fieldProps,
            text: text
          });
        })
      })
    })
  }, properties.children);
};